export { default } from "./TextClamp.vue";
